import http from "../http-common";

/**
 * Geofence Service
 * API service layer for geofencing operations
 */

class GeofenceService {
  /**
   * Create a new geofence
   * @param {Object} data - Geofence data
   */
  createGeofence(data) {
    return http.post("/geofence/create", data);
  }

  /**
   * Update existing geofence
   * @param {String} geofenceId - Geofence ID
   * @param {Object} data - Updated geofence data
   */
  updateGeofence(geofenceId, data) {
    return http.put(`/geofence/${geofenceId}`, data);
  }

  /**
   * Get all geofences for a profile
   * @param {String} profileId - Profile ID
   * @param {String} serialNumber - Device serial number
   */
  getGeofences(profileId, serialNumber) {
    return http.get("/geofence/list", {
      params: { profileId, serialNumber }
    });
  }

  /**
   * Get single geofence by ID
   * @param {String} geofenceId - Geofence ID
   * @param {String} profileId - Profile ID
   * @param {String} serialNumber - Device serial number
   */
  getGeofenceById(geofenceId, profileId, serialNumber) {
    return http.get(`/geofence/${geofenceId}`, {
      params: { profileId, serialNumber }
    });
  }

  /**
   * Delete geofence
   * @param {String} geofenceId - Geofence ID
   * @param {Object} data - Contains profileId and serialNumber
   */
  deleteGeofence(geofenceId, data) {
    return http.delete(`/geofence/${geofenceId}`, { data });
  }

  /**
   * Toggle geofence active/inactive status
   * @param {String} geofenceId - Geofence ID
   * @param {Object} data - Contains profileId and serialNumber
   */
  toggleGeofenceStatus(geofenceId, data) {
    return http.patch(`/geofence/${geofenceId}/toggle`, data);
  }

  /**
   * Get history for specific geofence
   * @param {String} geofenceId - Geofence ID
   * @param {Object} params - Query parameters (profileId, serialNumber, startDate, endDate, eventType, page, limit)
   */
  getGeofenceHistory(geofenceId, params) {
    return http.get(`/geofence/${geofenceId}/history`, { params });
  }

  /**
   * Get all history for a profile (across all geofences)
   * @param {Object} params - Query parameters (profileId, serialNumber, startDate, endDate, eventType, page, limit)
   */
  getAllHistory(params) {
    return http.get("/geofence/history/all", { params });
  }

  /**
   * Store location event (device tracking)
   * @param {Object} data - Location data (profileId, serialNumber, latitude, longitude)
   */
  storeLocationEvent(data) {
    return http.post("/geofence/store-location", data);
  }
}

export default new GeofenceService();